module.exports = __webpack_public_path__ + "assets/img/ZTS-HR22-M.f8acd387.png";